import {
    createSelector,
    createStructuredSelector
} from 'reselect'
import { createGetState } from '../../Redux/selector'
import {
    createValueSelector,
    createValueByNameSelector
} from '../../FormReducer/reducer'

export const mapStateToProps = () => {

    const getState = createGetState()
    const valueByName = createValueByNameSelector()
    const getValue = createValueSelector()

    const value = createSelector(
        getState,
        (_, props) => props,
        getValue
    )

    const valueMap = createSelector(
        getState,
        (_, props) => props,
        (localState, props) => {
            const {
                nameMap
            } = props
            const vMap = {}
            if (nameMap) {
                Object.keys(nameMap).forEach((nameKey) => {
                    const nameValue = nameMap[nameKey]
                    vMap[nameValue] = valueByName(localState, props, nameValue)
                })
            }
            return vMap
        }
    )

    return createStructuredSelector({
        value,
        valueMap
    })
}
